'use client'

import { CONSENT_EVENT } from '@/lib/consent'

/**
 * The way back to the banner, which is the other half of asking: consent that
 * cannot be withdrawn as easily as it was given is not consent.
 *
 * It says nothing itself — the banner listens for this event and reopens on
 * its settings — which keeps the footer a server component.
 */
export function ConsentPreferences() {
    return (
        <button
            type="button"
            onClick={() => document.dispatchEvent(new Event(CONSENT_EVENT))}
            className="cursor-pointer border-0 bg-transparent p-0 font-mono text-[11px] text-faint transition-colors duration-200 hover:text-accent"
        >
            Cookievoorkeuren
        </button>
    )
}
